module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container teamMemberInfoContainer"
  }, [_c('div', {
    staticClass: "modal-window-tab-mark"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-close-button",
    on: {
      "click": function($event) {
        ;
        _vm.$emit('close')
      }
    }
  }, [_c('img', {
    staticClass: "fillImg",
    attrs: {
      "src": "images/x.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-wndow-content teamMemberInfo-modal-window-content"
  }, [_c('div', {
    staticClass: "teamMemberInfoImg"
  }, [(_vm.picture != '') ? _c('img', {
    staticClass: "fillImg",
    attrs: {
      "src": _vm.picture
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "teamMemberMoreInfoText"
  }, [_c('h3', [_c('b', [_vm._v(_vm._s(_vm.memberName))])]), _vm._v(" "), _c('div', {
    staticClass: "teamMemberMoreInfoTextField",
    domProps: {
      "innerHTML": _vm._s(_vm.info)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "teamMemberMoreInfoSong"
  }, [_c('div', {
    staticClass: "audioPlayerPath",
    attrs: {
      "id": "audioPlayerPath"
    },
    on: {
      "click": _vm.seekPlayer
    }
  }, [_c('div', {
    staticClass: "audioPlayerPathCompletion",
    style: ('width:' + _vm.songCompletion + '%')
  })]), _vm._v(" "), _c('div', {
    staticClass: "audioPlayerPlay",
    on: {
      "click": function($event) {
        return _vm.playSong()
      }
    }
  }, [_c('img', {
    staticClass: "fillImg",
    attrs: {
      "src": "images/play.png"
    }
  })]), _vm._v(" "), _c('audio', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "audioPlayer",
      "controls": ""
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.song,
      "type": "audio/mpeg"
    }
  }), _vm._v("\n\t\t\t\t\t\t\tYour browser does not support the audio element.\n\t\t\t\t\t\t")])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-256042a0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TeamMemberInfo.vue
// module id = 106
// module chunks = 0